import { ACT_PLC_CHANGE } from "../actions/ActionTypes";

const initialState = {
  placeList:[],
};

export default function(state = initialState, action) {
	if (action.type === ACT_PLC_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/PlaceReducer.js